/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApproveWorkflow } from '../models/ApproveWorkflow';
import type { ApproveWorkflowRequest } from '../models/ApproveWorkflowRequest';
import type { Attachment } from '../models/Attachment';
import type { AttachmentRequest } from '../models/AttachmentRequest';
import type { ChangeRequestOwner } from '../models/ChangeRequestOwner';
import type { ChangeRequestOwnerRequest } from '../models/ChangeRequestOwnerRequest';
import type { Control } from '../models/Control';
import type { CreateRequestComment } from '../models/CreateRequestComment';
import type { CreateRequestCommentRequest } from '../models/CreateRequestCommentRequest';
import type { CreateRequestForm } from '../models/CreateRequestForm';
import type { CreateRequestFormRequest } from '../models/CreateRequestFormRequest';
import type { Email } from '../models/Email';
import type { EmailRequest } from '../models/EmailRequest';
import type { ExtendRequest } from '../models/ExtendRequest';
import type { ExtendRequestRequest } from '../models/ExtendRequestRequest';
import type { FilterParameters } from '../models/FilterParameters';
import type { FilterParametersRequest } from '../models/FilterParametersRequest';
import type { Form } from '../models/Form';
import type { FormRequest } from '../models/FormRequest';
import type { GetMyRequests } from '../models/GetMyRequests';
import type { Group } from '../models/Group';
import type { GroupRequest } from '../models/GroupRequest';
import type { Hazard } from '../models/Hazard';
import type { HazardRequest } from '../models/HazardRequest';
import type { MyTokenObtainPair } from '../models/MyTokenObtainPair';
import type { MyTokenObtainPairRequest } from '../models/MyTokenObtainPairRequest';
import type { PasswordToken } from '../models/PasswordToken';
import type { PasswordTokenRequest } from '../models/PasswordTokenRequest';
import type { PatchedAttachmentRequest } from '../models/PatchedAttachmentRequest';
import type { PatchedFormRequest } from '../models/PatchedFormRequest';
import type { PatchedGroupRequest } from '../models/PatchedGroupRequest';
import type { PatchedHazardRequest } from '../models/PatchedHazardRequest';
import type { PatchedRequestApproverRequest } from '../models/PatchedRequestApproverRequest';
import type { PatchedRequestFormFieldValueRequest } from '../models/PatchedRequestFormFieldValueRequest';
import type { PatchedRequestRequest } from '../models/PatchedRequestRequest';
import type { PatchedTemplateRequest } from '../models/PatchedTemplateRequest';
import type { PatchedTemplateTypeRequest } from '../models/PatchedTemplateTypeRequest';
import type { PerformAction } from '../models/PerformAction';
import type { PerformActionRequest } from '../models/PerformActionRequest';
import type { Request } from '../models/Request';
import type { RequestApprover } from '../models/RequestApprover';
import type { RequestApproverRequest } from '../models/RequestApproverRequest';
import type { RequestComment } from '../models/RequestComment';
import type { RequestFormFieldValue } from '../models/RequestFormFieldValue';
import type { RequestFormFieldValueRequest } from '../models/RequestFormFieldValueRequest';
import type { RequestRequest } from '../models/RequestRequest';
import type { RequestsByRequestNumber } from '../models/RequestsByRequestNumber';
import type { ResetToken } from '../models/ResetToken';
import type { ResetTokenRequest } from '../models/ResetTokenRequest';
import type { WorkflowRole } from '../models/WorkflowRole';
import type { StartWorkflow } from '../models/StartWorkflow';
import type { StartWorkflowRequest } from '../models/StartWorkflowRequest';
import type { Template } from '../models/Template';
import type { TemplateRequest } from '../models/TemplateRequest';
import type { TemplateType } from '../models/TemplateType';
import type { TemplateTypeFilteredByGroups } from '../models/TemplateTypeFilteredByGroups';
import type { TemplateTypeRequest } from '../models/TemplateTypeRequest';
import type { TokenRefresh } from '../models/TokenRefresh';
import type { TokenRefreshRequest } from '../models/TokenRefreshRequest';
import type { User } from '../models/User';
import type { UserList } from '../models/UserList';
import type { ViewRequestApprover } from '../models/ViewRequestApprover';
import type { WorkOrder } from '../models/WorkOrder';
import type { WorksPlanRequests } from '../models/WorksPlanRequests';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ApiService {

    /**
     * @returns Group 
     * @throws ApiError
     */
    public static apiAccountsGroupsList(): CancelablePromise<Array<Group>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/accounts/groups/',
        });
    }

    /**
     * @param requestBody 
     * @returns Group 
     * @throws ApiError
     */
    public static apiAccountsGroupsCreate(
requestBody: GroupRequest,
): CancelablePromise<Group> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/accounts/groups/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this group.
     * @returns Group 
     * @throws ApiError
     */
    public static apiAccountsGroupsRetrieve(
id: number,
): CancelablePromise<Group> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/accounts/groups/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param id A unique integer value identifying this group.
     * @param requestBody 
     * @returns Group 
     * @throws ApiError
     */
    public static apiAccountsGroupsUpdate(
id: number,
requestBody: GroupRequest,
): CancelablePromise<Group> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/accounts/groups/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this group.
     * @param requestBody 
     * @returns Group 
     * @throws ApiError
     */
    public static apiAccountsGroupsPartialUpdate(
id: number,
requestBody?: PatchedGroupRequest,
): CancelablePromise<Group> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/accounts/groups/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this group.
     * @returns void 
     * @throws ApiError
     */
    public static apiAccountsGroupsDestroy(
id: number,
): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/accounts/groups/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Takes a set of user credentials and returns an access and refresh JSON web
 * token pair to prove the authentication of those credentials.
     * @param requestBody 
     * @returns MyTokenObtainPair 
     * @throws ApiError
     */
    public static apiAccountsLoginCreate(
requestBody: MyTokenObtainPairRequest,
): CancelablePromise<MyTokenObtainPair> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/accounts/login/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Takes a refresh type JSON web token and returns an access type JSON web
 * token if the refresh token is valid.
     * @param requestBody 
     * @returns TokenRefresh 
     * @throws ApiError
     */
    public static apiAccountsRefreshTokenCreate(
requestBody: TokenRefreshRequest,
): CancelablePromise<TokenRefresh> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/accounts/refresh_token/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static apiAccountsRegisterCreate(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/accounts/register/',
        });
    }

    /**
     * @param search A search term.
     * @returns UserList 
     * @throws ApiError
     */
    public static apiAccountsUsersList(
search?: string,
group?: number | null,
): CancelablePromise<Array<UserList>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/accounts/users/',
            query: {
                'search': search,
                // HAND-EDITED: restricts the directory to one Group, used by the
                // approver picker when a role slot has a pool.
                'group': group,
            },
        });
    }

    /**
     * @param id A UUID string identifying this custom user.
     * @returns User 
     * @throws ApiError
     */
    public static apiAccountsUsersRetrieve(
id: string,
): CancelablePromise<User> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/accounts/users/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param hazardId 
     * @param search 
     * @returns Control 
     * @throws ApiError
     */
    public static apiAssessmentGetControlsByQueryList(
hazardId: number,
search?: string,
): CancelablePromise<Array<Control>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assessment/get-controls-by-query/',
            query: {
                'hazard_id': hazardId,
                'search': search,
            },
        });
    }

    /**
     * @param search 
     * @returns Hazard 
     * @throws ApiError
     */
    public static apiAssessmentGetHazardsByQueryList(
search: string,
): CancelablePromise<Array<Hazard>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assessment/get-hazards-by-query/',
            query: {
                'search': search,
            },
        });
    }

    /**
     * @param formId 
     * @returns Hazard 
     * @throws ApiError
     */
    public static apiAssessmentGetHazardsList(
formId: number,
): CancelablePromise<Array<Hazard>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assessment/get-hazards/{form_id}/',
            path: {
                'form_id': formId,
            },
        });
    }

    /**
     * @returns Hazard 
     * @throws ApiError
     */
    public static apiAssessmentHazardsList(): CancelablePromise<Array<Hazard>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assessment/hazards/',
        });
    }

    /**
     * @param requestBody 
     * @returns Hazard 
     * @throws ApiError
     */
    public static apiAssessmentHazardsCreate(
requestBody: HazardRequest,
): CancelablePromise<Hazard> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/assessment/hazards/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this hazard.
     * @returns Hazard 
     * @throws ApiError
     */
    public static apiAssessmentHazardsRetrieve(
id: number,
): CancelablePromise<Hazard> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assessment/hazards/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param id A unique integer value identifying this hazard.
     * @param requestBody 
     * @returns Hazard 
     * @throws ApiError
     */
    public static apiAssessmentHazardsUpdate(
id: number,
requestBody: HazardRequest,
): CancelablePromise<Hazard> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/assessment/hazards/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this hazard.
     * @param requestBody 
     * @returns Hazard 
     * @throws ApiError
     */
    public static apiAssessmentHazardsPartialUpdate(
id: number,
requestBody?: PatchedHazardRequest,
): CancelablePromise<Hazard> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/assessment/hazards/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this hazard.
     * @returns void 
     * @throws ApiError
     */
    public static apiAssessmentHazardsDestroy(
id: number,
): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/assessment/hazards/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param hazardId 
     * @returns Control 
     * @throws ApiError
     */
    public static apiAssessmentLastFiveControlsList(
hazardId: number,
): CancelablePromise<Array<Control>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assessment/last-five-controls/',
            query: {
                'hazard_id': hazardId,
            },
        });
    }

    /**
     * @returns Hazard 
     * @throws ApiError
     */
    public static apiAssessmentLastFiveHazardsList(): CancelablePromise<Array<Hazard>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assessment/last-five-hazards/',
        });
    }

    /**
     * @returns Attachment 
     * @throws ApiError
     */
    public static apiMainAttachmentsList(): CancelablePromise<Array<Attachment>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/attachments/',
        });
    }

    /**
     * @param requestBody 
     * @returns Attachment 
     * @throws ApiError
     */
    public static apiMainAttachmentsCreate(
requestBody: AttachmentRequest,
): CancelablePromise<Attachment> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/attachments/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this attachment.
     * @returns Attachment 
     * @throws ApiError
     */
    public static apiMainAttachmentsRetrieve(
id: number,
): CancelablePromise<Attachment> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/attachments/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param id A unique integer value identifying this attachment.
     * @param requestBody 
     * @returns Attachment 
     * @throws ApiError
     */
    public static apiMainAttachmentsUpdate(
id: number,
requestBody: AttachmentRequest,
): CancelablePromise<Attachment> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/main/attachments/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this attachment.
     * @param requestBody 
     * @returns Attachment 
     * @throws ApiError
     */
    public static apiMainAttachmentsPartialUpdate(
id: number,
requestBody?: PatchedAttachmentRequest,
): CancelablePromise<Attachment> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/main/attachments/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this attachment.
     * @returns void 
     * @throws ApiError
     */
    public static apiMainAttachmentsDestroy(
id: number,
): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/main/attachments/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns ChangeRequestOwner 
     * @throws ApiError
     */
    public static apiMainChangeRequestOwnerCreate(
requestBody: ChangeRequestOwnerRequest,
): CancelablePromise<ChangeRequestOwner> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/change-request-owner/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param requestBody 
     * @returns CreateRequestComment 
     * @throws ApiError
     */
    public static apiMainCreateRequestCommentCreate(
requestBody: CreateRequestCommentRequest,
): CancelablePromise<CreateRequestComment> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/create-request-comment/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param requestId 
     * @returns any No response body
     * @throws ApiError
     */
    public static apiMainDownloadDocumentRetrieve(
requestId: number,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/download-document/{request_id}/',
            path: {
                'request_id': requestId,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns ExtendRequest 
     * @throws ApiError
     */
    public static apiMainExtendRequestCreate(
requestBody: ExtendRequestRequest,
): CancelablePromise<ExtendRequest> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/extend-request/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns RequestFormFieldValue 
     * @throws ApiError
     */
    public static apiMainFormFieldValuesList(): CancelablePromise<Array<RequestFormFieldValue>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/form-field-values/',
        });
    }

    /**
     * @param requestBody 
     * @returns RequestFormFieldValue 
     * @throws ApiError
     */
    public static apiMainFormFieldValuesCreate(
requestBody: RequestFormFieldValueRequest,
): CancelablePromise<RequestFormFieldValue> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/form-field-values/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this request form field value.
     * @returns RequestFormFieldValue 
     * @throws ApiError
     */
    public static apiMainFormFieldValuesRetrieve(
id: number,
): CancelablePromise<RequestFormFieldValue> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/form-field-values/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param id A unique integer value identifying this request form field value.
     * @param requestBody 
     * @returns RequestFormFieldValue 
     * @throws ApiError
     */
    public static apiMainFormFieldValuesUpdate(
id: number,
requestBody: RequestFormFieldValueRequest,
): CancelablePromise<RequestFormFieldValue> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/main/form-field-values/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this request form field value.
     * @param requestBody 
     * @returns RequestFormFieldValue 
     * @throws ApiError
     */
    public static apiMainFormFieldValuesPartialUpdate(
id: number,
requestBody?: PatchedRequestFormFieldValueRequest,
): CancelablePromise<RequestFormFieldValue> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/main/form-field-values/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this request form field value.
     * @returns void 
     * @throws ApiError
     */
    public static apiMainFormFieldValuesDestroy(
id: number,
): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/main/form-field-values/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns Form 
     * @throws ApiError
     */
    public static apiMainFormsList(): CancelablePromise<Array<Form>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/forms/',
        });
    }

    /**
     * @param requestBody 
     * @returns Form 
     * @throws ApiError
     */
    public static apiMainFormsCreate(
requestBody: FormRequest,
): CancelablePromise<Form> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/forms/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this form.
     * @returns Form 
     * @throws ApiError
     */
    public static apiMainFormsRetrieve(
id: number,
): CancelablePromise<Form> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/forms/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param id A unique integer value identifying this form.
     * @param requestBody 
     * @returns Form 
     * @throws ApiError
     */
    public static apiMainFormsUpdate(
id: number,
requestBody: FormRequest,
): CancelablePromise<Form> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/main/forms/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this form.
     * @param requestBody 
     * @returns Form 
     * @throws ApiError
     */
    public static apiMainFormsPartialUpdate(
id: number,
requestBody?: PatchedFormRequest,
): CancelablePromise<Form> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/main/forms/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this form.
     * @returns void 
     * @throws ApiError
     */
    public static apiMainFormsDestroy(
id: number,
): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/main/forms/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param requestId 
     * @returns any No response body
     * @throws ApiError
     */
    public static apiMainGenerateDocumentRetrieve(
requestId: number,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/generate-document/{request_id}/',
            path: {
                'request_id': requestId,
            },
        });
    }

    /**
     * @param requestId 
     * @returns any No response body
     * @throws ApiError
     */
    public static apiMainGetRequestCmsRetrieve(
requestId: number,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/get-request-cms/{request_id}/',
            path: {
                'request_id': requestId,
            },
        });
    }

    /**
     * @param requestId 
     * @returns any No response body
     * @throws ApiError
     */
    public static apiMainGetRequestDocRetrieve(
requestId: number,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/get-request-doc/{request_id}/',
            path: {
                'request_id': requestId,
            },
        });
    }

    /**
     * @param search 
     * @returns RequestsByRequestNumber 
     * @throws ApiError
     */
    public static apiMainGetRequestsByNumberList(
search: string,
): CancelablePromise<Array<RequestsByRequestNumber>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/get-requests-by-number/',
            query: {
                'search': search,
            },
        });
    }

    /**
     * @returns GetMyRequests 
     * @throws ApiError
     */
    public static apiMainLast10RequestsList(): CancelablePromise<Array<GetMyRequests>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/last-10-requests/',
        });
    }

    /**
     * @param requestId 
     * @returns RequestComment 
     * @throws ApiError
     */
    public static apiMainListRequestCommentsList(
requestId: number,
): CancelablePromise<Array<RequestComment>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/list-request-comments/{request_id}/',
            path: {
                'request_id': requestId,
            },
        });
    }

    /**
     * @returns GetMyRequests 
     * @throws ApiError
     */
    public static apiMainMyRequestsList(
filters?: Record<string, any>,
): CancelablePromise<Array<GetMyRequests>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/my-requests/',
            query: filters,
        });
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static apiMainRequestStatusesList(): CancelablePromise<Array<{ id: string; name: string }>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/request-statuses/',
        });
    }

    /**
     * @param requestBody 
     * @returns PerformAction 
     * @throws ApiError
     */
    public static apiMainPerformActionCreate(
requestBody: PerformActionRequest,
): CancelablePromise<PerformAction> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/perform-action/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns RequestApprover 
     * @throws ApiError
     */
    public static apiMainRequestApproversList(): CancelablePromise<Array<RequestApprover>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/request-approvers/',
        });
    }

    /**
     * @param requestBody 
     * @returns RequestApprover 
     * @throws ApiError
     */
    public static apiMainRequestApproversCreate(
requestBody: RequestApproverRequest,
): CancelablePromise<RequestApprover> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/request-approvers/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this request approver.
     * @returns RequestApprover 
     * @throws ApiError
     */
    public static apiMainRequestApproversRetrieve(
id: number,
): CancelablePromise<RequestApprover> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/request-approvers/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param id A unique integer value identifying this request approver.
     * @param requestBody 
     * @returns RequestApprover 
     * @throws ApiError
     */
    public static apiMainRequestApproversUpdate(
id: number,
requestBody: RequestApproverRequest,
): CancelablePromise<RequestApprover> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/main/request-approvers/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this request approver.
     * @param requestBody 
     * @returns RequestApprover 
     * @throws ApiError
     */
    public static apiMainRequestApproversPartialUpdate(
id: number,
requestBody?: PatchedRequestApproverRequest,
): CancelablePromise<RequestApprover> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/main/request-approvers/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this request approver.
     * @returns void 
     * @throws ApiError
     */
    public static apiMainRequestApproversDestroy(
id: number,
): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/main/request-approvers/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param requestId 
     * @param workflowId 
     * @returns ViewRequestApprover 
     * @throws ApiError
     */
    public static apiMainRequestApproversGetApproversList(
requestId: string,
workflowId: number,
): CancelablePromise<Array<ViewRequestApprover>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/request-approvers/get_approvers/',
            query: {
                'request_id': requestId,
                'workflow_id': workflowId,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns CreateRequestForm 
     * @throws ApiError
     */
    public static apiMainRequestFormCreate(
requestBody: CreateRequestFormRequest,
): CancelablePromise<CreateRequestForm> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/request-form/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param formId 
     * @param requestId 
     * @returns any No response body
     * @throws ApiError
     */
    public static apiMainRequestFormRetrieve(
formId: number,
requestId: number,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/request-form/{request_id}/{form_id}/',
            path: {
                'form_id': formId,
                'request_id': requestId,
            },
        });
    }

    /**
     * @param id 
     * @returns any No response body
     * @throws ApiError
     */
    public static apiMainRequestHistoryRetrieve(
id: number,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/request-history/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns ApproveWorkflow 
     * @throws ApiError
     */
    public static apiMainRequestWorkflowApproveCreate(
requestBody: ApproveWorkflowRequest,
): CancelablePromise<ApproveWorkflow> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/request-workflow/approve/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param requestBody 
     * @returns ApproveWorkflow 
     * @throws ApiError
     */
    public static apiMainRequestWorkflowRejectCreate(
requestBody: ApproveWorkflowRequest,
): CancelablePromise<ApproveWorkflow> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/request-workflow/reject/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * HAND-ADDED: the named signature slots for one approval stage.
     * Empty array = legacy stage (pick any N users).
     * @param workflowId
     * @returns WorkflowRole
     * @throws ApiError
     */
    public static apiMainWorkflowRolesList(
workflowId: number,
): CancelablePromise<Array<WorkflowRole>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/workflow-roles/{workflow_id}/',
            path: {
                'workflow_id': workflowId,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns StartWorkflow 
     * @throws ApiError
     */
    public static apiMainRequestWorkflowStartCreate(
requestBody: StartWorkflowRequest,
): CancelablePromise<StartWorkflow> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/request-workflow/start/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param shortName 
     * @returns any No response body
     * @throws ApiError
     */
    public static apiMainRequestStatusesByShortNameRetrieve(
shortName: string,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/request_statuses_by_short_name/{short_name}/',
            path: {
                'short_name': shortName,
            },
        });
    }

    /**
     * @param templateId 
     * @returns any No response body
     * @throws ApiError
     */
    public static apiMainRequestStatusesByTemplateRetrieve(
templateId: number,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/request_statuses_by_template/{template_id}/',
            path: {
                'template_id': templateId,
            },
        });
    }

    /**
     * @returns Request 
     * @throws ApiError
     */
    public static apiMainRequestsList(
filters?: Record<string, any>,
): CancelablePromise<Array<Request>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/requests/',
            query: filters,
        });
    }

    /**
     * @param requestBody 
     * @returns Request 
     * @throws ApiError
     */
    public static apiMainRequestsCreate(
requestBody: RequestRequest,
): CancelablePromise<Request> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/requests/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param requestBody 
     * @returns FilterParameters 
     * @throws ApiError
     */
    public static apiMainRequestsByTemplateCreate(
requestBody: FilterParametersRequest,
): CancelablePromise<FilterParameters> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/requests-by-template/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this request.
     * @returns Request 
     * @throws ApiError
     */
    public static apiMainRequestsRetrieve(
id: number,
): CancelablePromise<Request> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/requests/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param id A unique integer value identifying this request.
     * @param requestBody 
     * @returns Request 
     * @throws ApiError
     */
    public static apiMainRequestsUpdate(
id: number,
requestBody: RequestRequest,
): CancelablePromise<Request> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/main/requests/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this request.
     * @param requestBody 
     * @returns Request 
     * @throws ApiError
     */
    public static apiMainRequestsPartialUpdate(
id: number,
requestBody?: PatchedRequestRequest,
): CancelablePromise<Request> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/main/requests/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this request.
     * @returns void 
     * @throws ApiError
     */
    public static apiMainRequestsDestroy(
id: number,
): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/main/requests/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param userId 
     * @returns Request 
     * @throws ApiError
     */
    public static apiMainRequestsGetRequestsForApprovalList(
userId: string,
filters?: Record<string, any>,
): CancelablePromise<Array<Request>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/requests/get_requests_for_approval/',
            query: {
                'user_id': userId,
                ...(filters || {}),
            },
        });
    }

    /**
     * @param shortName 
     * @returns any No response body
     * @throws ApiError
     */
    public static apiMainSearchFieldsByTemplateRetrieve(
shortName: string,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/search-fields-by-template/{short_name}/',
            path: {
                'short_name': shortName,
            },
        });
    }

    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static apiMainStatusRequestCountRetrieve(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/status-request-count/',
        });
    }

    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static apiMainTemplateRequestCountRetrieve(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/template-request-count/',
        });
    }

    /**
     * @param type 
     * @returns TemplateTypeFilteredByGroups 
     * @throws ApiError
     */
    public static apiMainTemplateTypesList(
type: string,
): CancelablePromise<Array<TemplateTypeFilteredByGroups>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/template-types/',
            query: {
                'type': type,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns TemplateType 
     * @throws ApiError
     */
    public static apiMainTemplateTypesCreate(
requestBody: TemplateTypeRequest,
): CancelablePromise<TemplateType> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/template-types/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this template type.
     * @returns TemplateType 
     * @throws ApiError
     */
    public static apiMainTemplateTypesRetrieve(
id: number,
): CancelablePromise<TemplateType> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/template-types/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param id A unique integer value identifying this template type.
     * @param requestBody 
     * @returns TemplateType 
     * @throws ApiError
     */
    public static apiMainTemplateTypesUpdate(
id: number,
requestBody: TemplateTypeRequest,
): CancelablePromise<TemplateType> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/main/template-types/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this template type.
     * @param requestBody 
     * @returns TemplateType 
     * @throws ApiError
     */
    public static apiMainTemplateTypesPartialUpdate(
id: number,
requestBody?: PatchedTemplateTypeRequest,
): CancelablePromise<TemplateType> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/main/template-types/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id A unique integer value identifying this template type.
     * @returns void 
     * @throws ApiError
     */
    public static apiMainTemplateTypesDestroy(
id: number,
): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/main/template-types/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns Template 
     * @throws ApiError
     */
    public static apiMainTemplatesList(): CancelablePromise<Array<Template>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/templates/',
        });
    }

    /**
     * @param requestBody 
     * @returns Template 
     * @throws ApiError
     */
    public static apiMainTemplatesCreate(
requestBody: TemplateRequest,
): CancelablePromise<Template> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/main/templates/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param shortName 
     * @returns Template 
     * @throws ApiError
     */
    public static apiMainTemplatesRetrieve(
shortName: string,
): CancelablePromise<Template> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/templates/{short_name}/',
            path: {
                'short_name': shortName,
            },
        });
    }

    /**
     * @param shortName 
     * @param requestBody 
     * @returns Template 
     * @throws ApiError
     */
    public static apiMainTemplatesUpdate(
shortName: string,
requestBody: TemplateRequest,
): CancelablePromise<Template> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/main/templates/{short_name}/',
            path: {
                'short_name': shortName,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param shortName 
     * @param requestBody 
     * @returns Template 
     * @throws ApiError
     */
    public static apiMainTemplatesPartialUpdate(
shortName: string,
requestBody?: PatchedTemplateRequest,
): CancelablePromise<Template> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/main/templates/{short_name}/',
            path: {
                'short_name': shortName,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param shortName 
     * @returns void 
     * @throws ApiError
     */
    public static apiMainTemplatesDestroy(
shortName: string,
): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/main/templates/{short_name}/',
            path: {
                'short_name': shortName,
            },
        });
    }

    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static apiMainTotalCountsRetrieve(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/total-counts/',
        });
    }

    /**
     * @returns WorksPlanRequests 
     * @throws ApiError
     */
    public static apiMainWorksPlanRequestsList(): CancelablePromise<Array<WorksPlanRequests>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/main/works-plan-requests/',
        });
    }

    /**
     * An Api View which provides a method to request a password reset token based on an e-mail address
 *
 * Sends a signal reset_password_token_created when a reset token was created
     * @param requestBody 
     * @returns Email 
     * @throws ApiError
     */
    public static apiPasswordResetCreate(
requestBody: EmailRequest,
): CancelablePromise<Email> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/password_reset/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * An Api View which provides a method to reset a password based on a unique token
     * @param requestBody 
     * @returns PasswordToken 
     * @throws ApiError
     */
    public static apiPasswordResetConfirmCreate(
requestBody: PasswordTokenRequest,
): CancelablePromise<PasswordToken> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/password_reset/confirm/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * An Api View which provides a method to verify that a token is valid
     * @param requestBody 
     * @returns ResetToken 
     * @throws ApiError
     */
    public static apiPasswordResetValidateTokenCreate(
requestBody: ResetTokenRequest,
): CancelablePromise<ResetToken> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/password_reset/validate_token/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param endDate 
     * @param location 
     * @param startDate 
     * @returns Request 
     * @throws ApiError
     */
    public static apiSimopsNearbyRequestList(
endDate: string,
location: string,
startDate: string,
): CancelablePromise<Array<Request>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/simops/nearby_request/',
            query: {
                'end_date': endDate,
                'location': location,
                'start_date': startDate,
            },
        });
    }

    /**
     * @param number 
     * @returns WorkOrder 
     * @throws ApiError
     */
    public static apiWorkordersGetWorkorderRetrieve(
number: string,
): CancelablePromise<WorkOrder> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/workorders/get-workorder/{number}/',
            path: {
                'number': number,
            },
        });
    }

    /**
     * @param search 
     * @returns WorkOrder 
     * @throws ApiError
     */
    public static apiWorkordersGetWorkordersList(
search?: string,
): CancelablePromise<Array<WorkOrder>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/workorders/get-workorders/',
            query: {
                'search': search,
            },
        });
    }

}
